import { render, staticRenderFns } from "./UnauthorizedModal.vue?vue&type=template&id=706d4c27&scoped=true&"
import script from "./UnauthorizedModal.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedModal.vue?vue&type=script&lang=js&"
import style0 from "./UnauthorizedModal.vue?vue&type=style&index=0&id=706d4c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d4c27",
  null
  
)

export default component.exports